import {Injector, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TaxonomyMenuComponent} from './taxonomy-menu.component';
// TODO: Angular16Fix TreeModule
// import {TreeModule} from "@circlon/angular-tree-component";
import {createCustomElement} from "@angular/elements";
import {RouterModule} from "@angular/router";
import {MatSelectModule} from '@angular/material/select';
import {SafePipeModule} from "@signature-it/ngx-generic/pipes";
import {EntityBlockModuleGeneric} from "@signature-it/ngx-entity/components/entity-block";
import { AutofocusDirectiveModule } from '@signature-it/ngx-generic/directives';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        // TreeModule,
        RouterModule,
        MatSelectModule,
        SafePipeModule,
        EntityBlockModuleGeneric,
        AutofocusDirectiveModule
    ],

    declarations: [TaxonomyMenuComponent],
    exports: [TaxonomyMenuComponent],
})
export class TaxonomyMenuModuleGeneric {
    constructor(private injector: Injector) {
        const TaxonomyMenuComp = createCustomElement(TaxonomyMenuComponent, {injector});
        !customElements.get('ngx-taxonomy-menu') && customElements.define('ngx-taxonomy-menu', TaxonomyMenuComp);
    }
}
